<template>
  <hr
    class="divider-component"
    :class="[spacingClass, variant]"
  />
</template>

<script>
export default {
  name: 'Divider',
  props: {
    spacing: {
      type: String,
      default: 'lg',
    },
    variant: {
      type: String,
    },
  },
  computed: {
    spacingClass() {
      return `spacing-${this.spacing}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.divider-component {
  background-color: #000000;
  border: none;
  color: #000000;
  height: 1px;

  &.spacing-sm {
    margin: rem-calc(16) 0;
  }

  &.spacing-md {
    margin: rem-calc(40) 0;
  }

  &.spacing-lg {
    margin: rem-calc(64) 0;
  }

  &.spacing-xl {
    margin: rem-calc(128) 0;
  }

  &.lightgrey {
    background-color: #e9e9e9;
    color: #e9e9e9;
  }
}
</style>
